var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstmove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MOUSE_MAP_FIRST_MOVE_SYMBOL",
    width: "222px",
    height: "301px",
    viewBox: "0 0 222 301",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "firstmove",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#E71202"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.294089,90.6517241 C207.36798,25.7748768 142.461576,-13.9492611 79.2990148,4.55320197 C36.9738916,16.9374384 6.08719212,53.3512315 0.855665025,97.464532 C-2.54334975,126.031034 4.22512315,152.173892 21.0428571,175.538424 C45.0871921,208.937438 69.2793103,242.247783 93.3975369,275.587685 C99.0576355,283.405419 104.702956,291.223153 110.569951,299.321675 C111.308867,298.30197 111.9,297.533498 112.461576,296.750246 C122.909852,282.311823 133.328571,267.858621 143.762069,253.434975 C162.530542,227.484236 181.417241,201.622167 200.082266,175.597537 C218.422167,150.031034 224.968966,121.494089 219.294089,90.6517241",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstmove);
export default __webpack_public_path__ + "static/media/firstmove.bc0c5a4a7507fa84385d22c9b30d4cfb.svg";
export { ForwardRef as ReactComponent };